import styled from 'styled-components';

const PageBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  padding-top: 3.75rem;
  background: ${({ theme }) => theme.white};

  @media screen and (min-width: 1280px) {
    width: calc(100% - 15.5rem);
    margin-left: 15.5rem;
  }

  @media screen and (max-width: 1279px) {
    padding-top: 3.75rem;
  }

  @media screen and (max-width: 767px) {
    padding-top: calc(3.125rem + 1rem);
  }
`;

export default PageBody;
